// Local translations
export const T = {
  en_GB: {
    invalidConfiguration: "Invalid configuration",
  },
  nb_NO: {
    invalidConfiguration: "Ugyldig konfigurasjon",
  },
} as const;
